import { useMemo } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { PatientHealthPageModule } from './PatientHealth.Module';
import { routes } from './routes';

export function usePatientHealthModuleRoute() {
  return useMemo(() => {
    return {
      path: '/my-health',
      element: <PatientHealthPageModule />,
      children: routes([
        {
          path: 'encounter',
          lazy: () =>
            import('./Patients.Encounters.List/PatientEncounterListPage').then(
              ({ PatientEncounterListPage }) => ({
                Component: PatientEncounterListPage,
              }),
            ),
        },
        {
          path: 'document',
          lazy: () =>
            import('./Patients.Documents.List/PatientDocumentsListPage').then(
              ({ PatientDocumentListPage }) => ({
                Component: PatientDocumentListPage,
              }),
            ),
        },
        {
          index: true,
          element: <Navigate to="encounter" replace />,
        },
      ]),
    } satisfies RouteObject;
  }, []);
}
